// extracted by mini-css-extract-plugin
export default {"location":"Location_location__QtgWk","icon":"Location_icon__5415w","text":"Location_text__xT3ln"};